// extracted by mini-css-extract-plugin
export var button = "_il-2";
export var card = "_il-0";
export var closeButtonContainer = "_il-3";
export var iconContainer = "_il-1";